import React, { useEffect, useState, useRef } from "react";
import "./assests/css/style.css";
import imgurl from "./assests/images/imgurl";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { replace, useLocation, useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";
import { useTimer } from "react-timer-hook";
import axios from "axios";
import AlertComp from "./Alert";
import { Card, CardContent } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import mobileIcon from "./assests/images/newimages/ic-contact-mobile.svg";
import EditIcon from "@mui/icons-material/Edit";
import MainLoader from "./components/MainLoader";
import { useSelector, useDispatch } from 'react-redux'
import i18next from 'i18next';
import LanguageSelector from "./LanguageSelector";
import { postApi } from "./api/services";
import { setgender } from "./Reducers/reducer";
import { setLanguage } from "./Redux/languageSlice";
import { gTagTracking, serviceDown, trackEvent } from "./utils/UtilityFunctions";
import MobileHeader from "./components/MobileHeader";

import BorderColorIcon from '@mui/icons-material/BorderColor';

// const time = new Date();
//     time.setSeconds(time.getSeconds() + 300);
function OtpPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch()
  const [otp, setOtp] = useState("");
  const [expired, setExpired] = useState(false);
  const [alertopen, setalertopen] = useState(false);
  const [alertmsg, setalertmsg] = useState("Test");
  const [timeLeft, setTimeLeft] = useState(300); // 5 minutes in seconds
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const locale = useSelector((state) => state.language.langData);
  const [showClipboardBtn, setShowClipboardBtn] = useState(false);
  const abortControllerRef = useRef(null);
  const [errorMssg, setErrorMssg] = useState("");

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  }, []);

  useEffect(() => {
    const isAndroidChrome = /Android/i.test(navigator.userAgent) && /Chrome/i.test(navigator.userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const hasWebOTP = 'OTPCredential' in window;
    const hasClipboard = navigator.clipboard && navigator.clipboard.readText;

    if (isAndroidChrome && hasWebOTP) {
      abortControllerRef.current = new AbortController();

      navigator.credentials
        .get({
          otp: { transport: ['sms'] },
          signal: abortControllerRef.current.signal
        })
        .then((otpCredential) => {
          if (otpCredential && otpCredential.code) {
            setOtp(otpCredential.code);
          }
        })
        .catch((err) => {
          if (err.name !== 'AbortError') {
            console.log('WebOTP error:', err);
            if (hasClipboard) {
              setShowClipboardBtn(true);
            }
          }
        });
    } else if (!isIOS && hasClipboard) {
      setShowClipboardBtn(true);
    }

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const handleClipboardRead = async () => {
    try {
      const text = await navigator.clipboard.readText();
      const otpMatch = text.match(/\b\d{4}\b/);
      if (otpMatch) {
        setOtp(otpMatch[0]);
      }
    } catch (err) {
      console.log('Clipboard read error:', err);
    }
  };

  useEffect(() => {
    console.log("locationnnn", location);
    if(!location?.state?.from){
      let checkUserData = JSON.parse(sessionStorage.getItem("checkUser"));
      console.log("checkUserData", checkUserData);
      if(checkUserData){
        // navigate('imgupload')
      }
    }
    return () => {
      if(location?.state?.from){
        location.state = null
      }  
    }
  }, [location])

  useEffect(() => {
    const storedStartTime = localStorage.getItem("otpStartTime");
    if (storedStartTime) {
      const elapsed = Math.floor(
        (Date.now() - parseInt(storedStartTime)) / 1000
      );
      if (elapsed < 300) {
        setTimeLeft(300 - elapsed);
      } else {
        setExpired(true);
      }
    } else {
      resetTimer();
    }
  }, []);

  // Reset the timer when the page/component loads
  useEffect(() => {
    resetTimer();
  }, []);

  useEffect(() => {
    if (expired || timeLeft <= 0) {
      setExpired(true);
      return;
    }

    const interval = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft, expired]);

  function resetTimer() {
    localStorage.setItem("otpStartTime", Date.now().toString());
    setTimeLeft(300);
    setExpired(false);
  }

  function resetOTP() {
    setLoading(true)
    let data = JSON.stringify({
      user_no: localStorage.getItem("phno"),
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://aloxa.ai/flaskservice/getotp",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        setLoading(false)
        resetTimer(); // Restart the 5-minute timer
      })
      .catch((error) => {
        setLoading(false)
        setalertmsg(
          "Error sending verification code. Please check Phone number."
        );
        setalertopen(true);
        setTimeout(() => {
          setalertopen(false);
        }, 4000);
        console.log(error);
      });
  }

  // function verifyOTP() {
  //   // Set loading state to true before making the API call
  //   setLoading(true); // Show loader

  //   let data = JSON.stringify({
  //     user_no: localStorage.getItem("phno"),
  //     otp: otp,
  //   });

  //   let no = {
  //     mobile_number: "+" + localStorage.getItem("phno"),
  //   };

  //   let config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: "https://aloxa.ai/flaskservice/verifyotp",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {

  //       var myHeaders = new Headers();
  //       myHeaders.append("Content-Type", "application/json");

  //       var raw = JSON.stringify({
  //         phone_number: parseInt(localStorage.getItem("phno")),
  //       });

  //       var requestOptions = {
  //         method: "POST",
  //         headers: myHeaders,
  //         body: raw,
  //         redirect: "follow",
  //       };
        
  //       // verifyotp()

  //       fetch(
  //         "https://aloxa.ai/flaskservice/check_user",
  //         requestOptions
  //       )
  //         .then((response) => response.text())
  //         .then((result) => {
  //           console.log("resultttttt", result);
            
  //           sessionStorage.setItem("checkUser", result);
  //           if (JSON.parse(result).user_exists) {
  //             navigate("/onboardingslider");
  //             // localStorage.setItem("valid_user", true);
  //             localStorage.setItem(
  //               "user_id",
  //               JSON.parse(result).user_id.user_id
  //             );
  //           } else {
  //             var myHeaders = new Headers();
  //             myHeaders.append("Content-Type", "application/json");

  //             var raw = JSON.stringify({
  //               phone_number: parseInt(localStorage.getItem("phno")),
  //               channel: window.cordova ? 'mobile' : 'webapp',
  //             });

  //             var requestOptions = {
  //               method: "POST",
  //               headers: myHeaders,
  //               body: raw,
  //               redirect: "follow",
  //             };

  //             fetch(
  //               "https://aloxa.ai/flaskservice/create_user",
  //               requestOptions
  //             )
  //               .then((response) => response.text())
  //               .then((result) => {
  //                 navigate("/onboardingslider");
  //                 // localStorage.setItem("valid_user", true);
  //                 localStorage.setItem(
  //                   "user_id",
  //                   JSON.parse(result).user_id.user_id
  //                 );
  //               })
  //               .catch((error) => console.log("error", error))
  //               .finally(() => {
  //                 setLoading(false); // Stop loader after the API call is finished
  //               });
  //           }
  //         })
  //         .catch((error) => {
  //           console.log("error", error);
  //         })
  //         .finally(() => {
  //           setLoading(false); // Stop loader after the API call is finished
  //         });
  //     })
  //     .catch((error) => {
  //       console.log("error", error);
        // setalertmsg("Verification code failed. Please try again.");
        // setalertopen(true);
        // setTimeout(() => {
        //   setalertopen(false);
        // }, 4000);
  //     })
  //     .finally(() => {
  //       setLoading(false); // Stop loader after the API call is finished
  //     });
  // }

  const verifyOTP = async () => {
    setLoading(true)
    const userObj = JSON.parse(localStorage.getItem('user_obj'))
    let params = {
      user_no: localStorage.getItem("phno"),
      otp: otp,
    }
    try{
      let res = await postApi('verifyotp', params)
      if(res?.error) {
        setLoading(false)
        await trackEvent('code_verification_completed', 'fail', res?.error, localStorage.getItem('phno'), userObj.user_id)
        await gTagTracking('code_verification_completed', {
          action: 'fail',
          error: res?.error,
          mobile_number: localStorage.getItem('phno'),
          user_id: userObj.user_id
        })
        setalertmsg(i18next.t("Verification code failed. Please try again."));
        setalertopen(true);
        setTimeout(() => {
          setalertopen(false);
        }, 4000);      
      } else {
        await trackEvent('code_verification_completed', 'success', '', localStorage.getItem('phno'), userObj.user_id)
        await gTagTracking('code_verification_completed', {
          action: 'success',
          error: '',
          mobile_number: localStorage.getItem('phno'),
          user_id: userObj.user_id
        })
        // checkUser()
        updatePhone()
      }
    } catch(err) {
      await trackEvent('code_verification_completed', 'fail', err, localStorage.getItem('phno'), userObj.user_id)
      await gTagTracking('code_verification_completed', {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno'),
        user_id: userObj.user_id
      })
      setLoading(true)
      setalertmsg(i18next.t("Verification code failed. Please try again."));
      setalertopen(true);
      setTimeout(() => {
        setalertopen(false);
      }, 4000);
      console.log("err", err)
    }
  }

  const updatePhone = async () => {
    setLoading(true)
    let userObj = JSON.parse(localStorage.getItem('user_obj'))
    let params = {
      user_id: userObj.user_id,
      gender: userObj.gender,
      phone_number: localStorage.getItem('phno')
    }
    console.log("update_user_phonenumber params", params);
    try {
      let res = await postApi('update_user_phonenumber', params)
      console.log("update_user_phonenumber res", res);
      setLoading(false)
      if(res.error) {
        swal({
          title: res.error,
          icon: 'warning',
          buttons: {
            // confirm: {
            //   text: i18next.t("Retake Test"),
            //   value: true,
            //   visible: true,
            // },
            cancel: {
              text: i18next.t("Ok"),
              value: false,
              visible: true,
            }, 
          },
          // className: "multiple-button-swal",
        }).then((val) => {
          if(val){
            // navigate('/taketest')
            navigate(`/${localStorage.getItem('channel') === 'alopexia-ads' ? 'c1' : 'start-test'}`)
          } else {
            return
          }
        })
      } else {
        localStorage.setItem('user_obj', JSON.stringify(res.user_obj))
        // getAiReportDetails(location?.state?.analysis_id)
        navigate("/report", { state: { analysis_id: location.state.analysis_id } });
        // if(res.user_obj.medical_history_present) {
        //   navigate('/prescriptions')
        // } else {
        //   navigate("/report", { state: { analysis_id: location.state.analysis_id } });
        // }
      }
    } catch (err) {
      console.log("err", err);
      setLoading(false)
      serviceDown()
    }
  }

  // const getAiReportDetails = async (id, old) => {
  //   const userObj = JSON.parse(localStorage.getItem('user_obj'))
  //   try{
  //     setLoading(true);
  //     let apiobj = {
  //       analysis_id: id,
  //     };
  //     console.log("get_ai_hair_analysis_report res", apiobj);
  //     const data = await postApi('get_ai_hair_analysis_report', apiobj)
  //     if (data) {
  //       console.log("get_ai_hair_analysis_report data", data);
  //       // await trackEvent('quick_report_viewed', 'success', "", localStorage.getItem('phno'), userObj.user_id)
  //       // await gTagTracking('quick_report_viewed', {
  //       //   action: 'success',
  //       //   error: '',
  //       //   mobile_number: localStorage.getItem('phno'),
  //       //   user_id: userObj.user_id
  //       // })
  //       if(old) {
  //         setOldReportDetails(data)
  //       } else {
  //         setReportDetails(data)
  //         setStage(data?.report?.norwood_stage)
  //         // google ads conversion event snippet
  //         // if(window?.gtag){
  //         //   window.gtag('event', 'conversion', {
  //         //     send_to: 'AW-17407079819/rKXYCOudoI0bEIvrq-xA',
  //         //     value: 0.0,
  //         //     currency: 'USD'
  //         //   });
  //         // }
  //       }
  //       setLoading(false)
  //     }
  //   } catch (err) {
  //     console.log("err", err)
  //     setLoading(false)
  //     // await trackEvent('quick_report_viewed', 'fail', err, localStorage.getItem('phno'), userObj.user_id)
  //     // await gTagTracking('quick_report_viewed', {
  //     //   action: 'fail',
  //     //   error: err,
  //     //   mobile_number: localStorage.getItem('phno'),
  //     //   user_id: userObj.user_id
  //     // })
  //     serviceDown()
  //   }
  // }

  const validateOtp = (event) => {
    const input = event;

    // Allow only digits
    if (!/^\d*$/.test(input)) {
      setErrorMssg("Only numeric characters are allowed.");
      return;
    }

    // Valid input
    setErrorMssg("");
    setOtp(input);
  };

  return (
    <>
      {loading && <MainLoader />}
      <div className="otppage">
        {/* <div className="otpbgimg toppg">
                </div> */}

        <div className="w-100">
          {/* <div className="languageOtpContainer">
            <div className="d-flex justify-content-start align-items-center gobackbtn otpBackbtn">
              <span
                className="backButtonDiv"
                onClick={() => navigate("/loginpage", { replace: true })}
              >
                <ArrowBackOutlinedIcon className="arrowBackBtn"></ArrowBackOutlinedIcon>
              </span>
            </div>
            <div className={window.cordova ? 'language-select-div' : 'language-select-div web'}>
              <LanguageSelector from={'OtpPage'}/>
               {isMobile && <MobileHeader showDrawer={true}/>}      
            </div>
          </div> */}
         

          <Card className="otpcard otpMainCard">
            <CardContent className="pb-16px w-100">
              {
                isMobile && 
                  <div className="loginpglogo mt-5px">
                    <img src={imgurl.hairlossaiLogo} className="mb-4 mt-0 otpLogo" alt="New Logo"/>
                  </div>
              }
              <div className="otppgtext">
                <p className="mb-5px otpText">{i18next.t("Enter Verification Code")}</p>
                <p className="mb-5px otpText sub">{i18next.t("A code has been sent to your mobile number by SMS")}
                  <span className="mobilenumber">
                    {"+"}
                    {localStorage.getItem("phno")}{" "}
                    <BorderColorIcon onClick={() => navigate("/loginpage", { state: { from: "otppage", analysis_id: location?.state?.analysis_id } })} />
                 </span>
                </p>
                <p className="editNumberField">
                  
                </p>
              </div>

              <div className="d-flex justify-content-center align-items-center">
                <span className="mobileBorder">
                  <img src={mobileIcon}></img>
                </span>
              </div>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <p className="otpCode">{i18next.t("Enter 4 Digit Code")}</p>
                </Grid>
              </Grid>

              <Grid container spacing={0} className="otptextfield">
                {/* <Grid item xs={3}>
                        <TextField id="outlined-basic" label="" variant="outlined" className="bluefield" />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField id="outlined-basic" label="" variant="outlined" className="whitefield" />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField id="outlined-basic" label="" variant="outlined" className="whitefield" />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField id="outlined-basic" label="" variant="outlined" className="whitefield" />
                    </Grid> */}

                <div className="otpFieldDiv">
                  <OtpInput
                    className="otp-input"
                    value={otp}
                    onChange={(e) => validateOtp(e)}
                    numInputs={4}
                    renderSeparator={<span> </span>}
                    renderInput={(props, index) => (
                      <input
                        {...props}
                        type="text"
                        inputMode='numeric'
                        autoComplete={index === 0 ? "one-time-code" : "off"}
                      />
                    )}
                  />
                  {errorMssg ? 
                    (
                      <div className="phoneNoErrorMessage">
                        {i18next.t(errorMssg)}
                      </div>
                    ) : (
                      ""
                    )
                  }
                </div>
              </Grid>

              <div className="otpinfotext">
                {/* <p>I didn't receive the code,</p> */}
                {!expired ? (
                  <div className="otpinfotextblue">
                    {i18next.t("Resend Verification Code in:")} {Math.floor(timeLeft / 60)}:
                    {(timeLeft % 60).toString().padStart(2, "0")}
                  </div>
                ) : (
                  <div className="otpinfotextblue cursor-pointer" onClick={resetOTP}>
                    {i18next.t("Resend Verification Code")}
                  </div>
                )}
              </div>

              {/* {showClipboardBtn && isMobile && (
                <Button
                  variant="outlined"
                  className="commonButton mt-10px"
                  onClick={handleClipboardRead}
                  style={{ marginBottom: '10px' }}
                >
                  {i18next.t("Paste OTP from Clipboard")}
                </Button>
              )} */}

              <Button
                variant="contained"
                className="commonButton mt-20px"
                onClick={() => verifyOTP()}
              >
                {i18next.t("Next")}
              </Button>
            </CardContent>
          </Card>

          {/* <Grid className="btnssection">
                        <Grid item xs={6}>
                            <div className="prevbtn">
                                <Button variant="contained" onClick={() => { navigate("/") }}>
                                    <div className="prevbtntext">
                                        <img src={imgurl.backarrow} alt="Backward arrows" />
                                        <p> Previous </p>
                                    </div>

                                </Button>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div className="nextbtn">
                                <Button variant="contained" onClick={() => verifyOTP()}>
                                    <div className="nextbtntext">
                                        <p> Next </p>
                                        <img src={imgurl.arrows} alt="Forward arrows" />
                                    </div>

                                </Button>
                            </div>
                        </Grid>
                    </Grid> */}
        </div>

        {/* <div className='shapeblue'>
                    <img src={imgurl.shapeblue} alt="Blue shape" />
                </div> */}

        <AlertComp open={alertopen} msg={alertmsg} type={"error"} />
      </div>
    </>
  );
}

export default OtpPage;
